export const mailStatusConstantes = Object.freeze({
  VALID: 1,
  TEMPORARY_BLOCK: 2,
  DEFINITIVE_BLOCK: 3,
});
